import { TravelerPaxResponse } from '@pax/entities/traveler-pax';
import { PaxType } from '@booking/entities/pax-type';

export function isActiveBonvoyNumberByAdults(travelers: TravelerPaxResponse[]): boolean {
  return travelers?.filter(
    traveler => traveler?.pax_type === PaxType.ADULTS
  )?.some(traveler => traveler?.bonvoy_number?.length > 0)
}
